import { useContext, useMemo } from "react";
import checkoutContext from "../../../../../checkout-context";
import { Address, CompanyDetails, PersonalDetails } from "../../../types/Types";
import { clsx } from "clsx";
import { isCompanyDetails } from "../../../utils/IsCompanyDetails";

function renderPersonalName(personalDetails: PersonalDetails) {
  return [
    personalDetails.salutation,
    personalDetails.initials,
    personalDetails.insertion,
    personalDetails.lastName,
  ]
    .filter((value) => value)
    .join(" ");
}

type InvoiceOptionCardProps = {
  option: Address | CompanyDetails;
  isActive: boolean;
  onClick: () => void;
  onEdit?: () => void;
};

export function InvoiceOptionCard({
  option,
  isActive,
  onClick,
  onEdit,
}: InvoiceOptionCardProps) {
  const Wrapper = onEdit ? "div" : "button";
  const { textsMapping } = useContext(checkoutContext);
  const { data: checkoutData } = useContext(checkoutContext);

  const { customerData } = checkoutData;
  const { personalDetails } = customerData;

  const isCompany = isCompanyDetails(option);
  const address = isCompany ? option.address : option;

  const personalName = useMemo(
    () => renderPersonalName(personalDetails),
    [personalDetails]
  );

  return (
    <Wrapper
      className={clsx(
        "invoice-option-card",
        isActive && "active",
        !onEdit && "button--link"
      )}
      onClick={onClick}
      type={onEdit ? undefined : "button"}
    >
      <h3 className="invoice-option-card__title">
        {isCompany
          ? textsMapping.invoiceOptionTypeCompany
          : textsMapping.invoiceOptionTypePersonal}
      </h3>
      <p>
        {isCompany ? option.name : personalName}
        <br />
        {`${address.street} ${address.houseNumber}${
          address.houseNumberAddition ? address.houseNumberAddition : ""
        }`}
        <br />
        {`${address.zip}, ${address.city}`}
        {!address.defaultCountry && (
          <>
            <br />
            {address.country}
          </>
        )}
        {isCompany && option.chamberOfCommerce && (
          <span className="invoice-option-card__company-details">
            {textsMapping.invoiceOptionCompanyChamberOfCommerce}{" "}
            {option.chamberOfCommerce}
          </span>
        )}
      </p>
      {onEdit && isActive && (
        <button
          onClick={onEdit}
          type="button"
          className="invoice-option-card__edit-button button--link icon-pencil"
        >
          {textsMapping.invoiceOptionCardEdit}
        </button>
      )}
    </Wrapper>
  );
}
